export const PLAUSIBLE_EVENTS = {
  LISTING_VIEWED: 'Listing Viewed',
  CONTACT_CLICKED: 'Contact Clicked',
  SIGNUP_COMPLETED: 'Signup Completed',
};

export const trackPlausibleEvent = (eventName, props = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.plausible !== 'function') {
    return;
  }

  try {
    window.plausible(eventName, { props });
  } catch (e) {
    // Analytics must never break user flows.
  }
};
